import type { AnySceneObjectT, TextI } from "tweenly"
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded"
import { Box, IconButton, Tooltip } from "@mui/material"
import { t } from "i18next"
import PropertyRow from "../../../common/PropertyTools/PropertyRow"
import TextArea from "../../../common/PropertyTools/TextArea"
import SelectAttributes from "../../DataSource/SelectAttributes"

interface Props {
    key: string
    index: number
    textsCount: number
    object: TextI
    handleUpdateText: (objectId: string, property: string, value: string) => void
    handleDeleteText: (object: AnySceneObjectT) => void
    textObjects: AnySceneObjectT[]
}

const TickerTextRow = ({
    key,
    index,
    textsCount,
    object,
    handleUpdateText,
    handleDeleteText,
}: Props) => {
    const disableMoveUp = index === 0
    const disableMoveDown = index + 1 === textsCount
    const disableDelete = disableMoveUp && disableMoveDown

    const handleAppendAttribute = (attribute: string) => {
        handleUpdateText(
            object.id,
            "text",
            !object.text || object.text === " " ? attribute : object.text + " " + attribute
        )
    }

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleUpdateText(object.id, e.target.name, e.target.value || " ")
    }

    return (
        // like a text's own field (see TextAndFont): its actions in the narrow column at the
        // end of the row, one above the other — the field is two lines tall
        <PropertyRow
            gutter={
                <Box display="flex" flexDirection="column" alignItems="center">
                    <SelectAttributes compact handleChange={handleAppendAttribute} />
                    <Tooltip title={t("editor:remove")}>
                        <span>
                            <IconButton
                                size="small"
                                disabled={disableDelete}
                                aria-label={t("editor:remove")}
                                onClick={() => handleDeleteText(object)}
                            >
                                <RemoveRoundedIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            }
        >
            <TextArea
                key={key}
                fullWidth
                rows={2}
                label={"text"}
                name="text"
                value={object.text}
                onChange={handleOnChange}
            />
        </PropertyRow>
    )
}

export default TickerTextRow
